module.exports = __webpack_public_path__ + "img/1REDBERRIES.8f4f671c.png";